module.exports = __webpack_public_path__ + "static/media/19.e072b1d1.svg";